import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

// import modules this module depends on
import angularTranslate from 'angular-translate';
import rnDevice from 'rhino/src/components/device/device.module';
import rnLocale from 'rhino/src/components/locale/locale.module';
import * as signUp from './sign-up.controller';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';
import gzEula from 'gazelle/src/components/user/eula/eula.module';

// import this modules components

import './sign-up.scss';

// define the module in one place and export the module name
export default angular.module('register.components.signup', [
  gzEula,
  uiRouter,
  rnDevice,
  rnLocale,
  ngMaterial,
  angularTranslate,
  'rhino.components.locale',
  'rhino.core',
  'angulartics',
  gazelleAnalytics
])
  .controller(signUp.name, signUp.default)
  .name;



// WEBPACK FOOTER //
// ./components/sign-up/sign-up.module.js